/**
 * Supabase refuses a second auth email to one address within a minute,
 * answering "For security purposes, you can only request this after 9
 * seconds." That arrives only because an email *was* just sent, so it is not
 * an error to show anyone — people re-submitting a form because the first
 * email was slow were getting exactly this.
 */
export function secondsUntilResend(message: string): number | null {
  const match = /only request this after (\d+) second/i.exec(message);
  return match ? Number(match[1]) : null;
}
